import api from 'api';

const sessionManager = {
    getSession() {
        return api.session.getCurrentSession();
    },
};

export default sessionManager;
